module.exports = "/static/assets/d275d18e306a6c36ccfa827bed3f4d45.png";